// extracted by mini-css-extract-plugin
export default {"stickableMenu":"VendingMachineMain_stickableMenu__Dak5r","placeHolderShimmer":"VendingMachineMain_placeHolderShimmer__VQtSY"};